import { createI18n } from 'vue-i18n'
import './blog-translations'

/* eslint-disable */
// Import language files
import da from './locales/da'
import en from './locales/en'
import sv from './locales/sv'
import nb from './locales/nb'
import de from './locales/de'
import th from './locales/th'
import pl from './locales/pl'
import fr from './locales/fr'
import tl from './locales/tl'
import pt from './locales/pt'

const messages = {
  da,  // Danish
  en,  // English
  sv,  // Swedish
  nb,  // Norwegian Bokmål
  de,  // German
  th,  // Thai
  pl,  // Polish
  fr,  // French
  tl,  // Tagalog
  pt   // Portuguese
}



// Available languages for the language switcher
export const availableLocales = [
  { code: 'da', name: 'Dansk', flag: '🇩🇰' },
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'sv', name: 'Svenska', flag: '🇸🇪' },
  { code: 'nb', name: 'Norsk', flag: '🇳🇴' },
  { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'pt', name: 'Português', flag: '🇵🇹' },
  { code: 'pl', name: 'Polski', flag: '🇵🇱' },
  { code: 'th', name: 'ภาษาไทย', flag: '🇹🇭' },
  { code: 'tl', name: 'Tagalog', flag: '🇵🇭' }
]

// Get saved language or detect from browser
const getSavedLanguage = () => {
  const saved = localStorage.getItem('language')
  if (saved && messages[saved]) {
    return saved
  }
  
  // Try to detect from browser
  const browserLang = navigator.language.split('-')[0]
  if (messages[browserLang]) {
    return browserLang
  }
  
  // Default to Danish
  return 'da'
}

const i18n = createI18n({
  legacy: false,
  locale: getSavedLanguage(),
  fallbackLocale: 'en',
  messages
})

export default i18n